module.exports = __webpack_public_path__ + "static/media/vacation_icon.52151222.svg";